/* eslint-disable jsx-a11y/anchor-has-content,react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import MediumPreLoader from 'components/Common/PreLoaders/MediumPreLoader';

import ContestView from './ContestView';

const ContestViewIndex = props => {
  if (
    !props.item ||
    !props.requestState ||
    props.requestState.requestInProcess
  ) {
    return <MediumPreLoader />;
  }
  return <ContestView {...props} />;
};

ContestViewIndex.defaultProps = {
  requestState: null,
  item: null
};

ContestViewIndex.propTypes = {
  // CONNECT STATES
  requestState: PropTypes.shape({
    requestInProcess: PropTypes.bool.isRequired
  }),
  item: PropTypes.shape({})
};

export default ContestViewIndex;



// WEBPACK FOOTER //
// ./src/components/Contest/layouts/ContestView/index.js